// extracted by mini-css-extract-plugin
export default {"contentContainer":"contentContainer--c1688","alert":"alert--d6e6c","footerReplacement":"footerReplacement--12194"};